/* eslint-disable import/no-commonjs */

/**
 * @type Record<
     "ADMIN" | "BUSINESS" | "NOTARY" | "CUSTOMER" | "VERIFY" | "LENDER" | "TITLE_AGENCY" | "CAPTURE",
     "admin" | "business" | "notary" | "customer" | "verify" | "lender" | "title_agency" | "capture"
   >
 */
module.exports = {
  ADMIN: "admin",
  BUSINESS: "business",
  NOTARY: "notary",
  CUSTOMER: "customer",
  VERIFY: "verify",
  LENDER: "lender",
  TITLE_AGENCY: "title_agency",
  CAPTURE: "capture",
};
